import { z } from 'zod';

// Schemas (source of truth) — pure validation, no transforms
export const activityLabelSchema = z.object({
	_id: z.string().optional(),
	projectId: z.string(),
	text: z.string(),
});

// Types (derived from schemas)
export type IActivityLabel = z.infer<typeof activityLabelSchema>;
